export default __webpack_public_path__ + "static/ceinture.en.cover-08bb194b157e7903f3bfdb2685a880f0.jpg";